import { Route } from '@angular/router';
import { applicationdata } from './applicationdata';
import { masterdata } from './masterdata';
import { content } from './content';
import { network } from './network';
import { RoutingID } from '../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';

export const datasets: Route = {
  path: 'datasets',
  title: 'nav.datasets',
  data: {
    icon: SbIcons.datasets,
    breadcrumb: 'nav.datasets',
  },
  children: [applicationdata, masterdata, network, content, { path: '', redirectTo: RoutingID.masterData, pathMatch: 'full' }],
};
